import React, { useEffect, useState } from "react";
import Room from "./Room";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { useActions } from "../redux/useActions";
import { getRooms as getRoomsAction } from "../actions/roomActions";
import { Grid, Typography, Button, Divider } from "@material-ui/core";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import RoomCard from "./RoomCard";
import SearchField from "./Input/SearchField";
import CreateRoom from "./CreateRoom";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },
  controls: {
    //paddingBottom: theme.spacing(1)
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));

export default function Rooms({ match }) {
  const classes = useStyles();
  const roomState = useSelector(state => state.rooms);
  const getRooms = useActions(() => getRoomsAction);

  const [search, setSearch] = useState("");

  const [showCreateRoom, setShowCreateRoom] = useState(false);

  //get list of rooms from api and render them in a grid
  useEffect(() => {
    async function getAllRooms() {
      await getRooms();
    }

    getAllRooms();
  }, [match]);

  if (match && !match.isExact) {
    return <Route path={`${match.path}/:roomId`} component={Room} />;
  } else {
    const { rooms } = roomState;

    return (
      <div className={classes.root}>
        <CreateRoom
          showCreateRoom={showCreateRoom}
          setShowCreateRoom={setShowCreateRoom}
        />
        <Grid container justify="space-between">
          <Grid item>
            <Typography variant="h5">Live Directory</Typography>
          </Grid>
          <Grid item>
            <Grid
              container
              className={classes.controls}
              justify="flex-end"
              spacing={1}
            >
              <Grid item>
                <SearchField search={search} setSearch={setSearch} />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setShowCreateRoom(true)}
                >
                  Create Room
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider className={classes.divider} />
        <Grid container spacing={1} justify="center">
          {rooms.map((room, index) => (
            <Grid item key={index} className={classes.room}>
              <RoomCard room={room} />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}
